import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { useMutation } from 'react-apollo'
import gql from 'graphql-tag'

import apolloClient from '../../apollo'
import { actions as authActions } from '../../reducers/auth'

const continueWithAuthMutation = gql`
mutation continueWithGolfbox($token: ID!, $provider: AuthProvider!) {
  continueWithAuth(input: {
    provider: $provider
    token: $token
  }) {
    provider
    id
    otp
    isNewUser
    name
    email
    clubId
    clubName
  }
}
`

const Connect = props => {
  const params = _.get('match.params', props)
  const provider = _.get('provider', params)
  const token = _.get('token', params)

  const [authenticate] = useMutation(continueWithAuthMutation, { client: apolloClient })

  const doAuthentication = async () => {
    try {
      const { data: { continueWithAuth } } = await authenticate({ variables: { provider, token } })
      if (continueWithAuth.isNewUser) {
        const { name, email, clubId, clubName } = continueWithAuth
        props.history.replace('/signup', {
          userProfile: _.omitBy(_.isNil, { // Drop nulls and undefineds as validator.js can't handle NULL
            name,
            email,
            clubId,
            clubName
          }),
          cameFromSocialSignup: true,
          socialSignupOutput: continueWithAuth
        })
      } else {
        const {
          id: email,
          otp: password,
          provider
        } = continueWithAuth
        props.doLogin({ email, password, provider })
      }
    } catch (err) {
      console.warn(err)
    }
  }

  React.useEffect(() => {
    if (token && provider) {
      doAuthentication()
    }
  }, [])

  if (!(token && provider)) {
    // TODO return to login?
    return null
  }

  return (
    <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column' }}>
      <div style={{ flex: 1 }} />
      <div style={{ flex: 1, justifyContent: 'center' }}>
        {/* <ActivityIndicator size='large' /> */}
        <span style={{ color: '#9E9E9E', fontSize: 24, paddingTop: 16 }}>Please wait</span>
      </div>
      <div style={{ flex: 1 }}>
        {/* <CenteredLogo /> */}
      </div>
    </div>
  )
}

export default _.compose(
  connect(() => ({}), ({
    doLogin: authActions.loginRequest
  }))
)(Connect)
